import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import type { Dispatch, SetStateAction } from 'react';

type ExcludeButtonProps = {
  text: string;
  disabled?: boolean;
  disabledReason?: string;
  onAddExclusion: Dispatch<SetStateAction<boolean>>;
};

export const ExcludeButton = ({ text, onAddExclusion, disabled = false, disabledReason }: ExcludeButtonProps) => {
  const button = (
    <Button
      data-test="add-excludes-group"
      variant="text"
      color="error"
      onClick={() => onAddExclusion(true)}
      disabled={disabled}
    >
      {text}
    </Button>
  );

  return (
    <Box
      component="span"
      sx={{
        pt: 1,
      }}
    >
      {disabled && disabledReason ? (
        <Tooltip title={disabledReason}>
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
    </Box>
  );
};
